import { connect } from 'react-redux';
import { trackEvent } from '../../user-tracking/actions.js';
import ErrorBoundary from './error-boundary.js';

export default connect(null, { trackEvent })(ErrorBoundary);
